import { ReleaseHighlightsBeheer } from "@/features/release-highlight";
import { Container } from "@/shared/components";
import { ErrorBoundary, ErrorDisplay } from "@/shared/components/error";

export default function ReleaseHighlightsPage() {
    return (
        <Container fluid>
            <ErrorBoundary
                fallback={(error) => <ErrorDisplay error={error} variant="section" title="Fout bij het laden van release hoogtepunten" />}
            >
                <ReleaseHighlightsBeheer />
            </ErrorBoundary>
        </Container>
    );
}
